/****************************************************************************************
 * Copyright (c) 2023. Peter Lemke, SV-Studios                                          *
 * This File, its contents and by extension the corresponding project is property of    *
 * SV-Studios and may not be used without explicit permission to do so.                 *
 *                                                                                      *
 * management@sv-studios.net                                                            *
 ****************************************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialRequired = Cookies.get("sv_cookie_required") === "true";
const initialAnalytics = Cookies.get("sv_cookie_analytics") === "true";
const initialPreferences = Cookies.get("sv_cookie_preferences") === "true";
const initialSupportPin = Cookies.get("support_pin");
let initialShowDialog = false;
if (initialRequired !== true) {
  initialShowDialog = true;
}

const cookieSlice = createSlice({
  name: "cookie",
  initialState: {
    required: initialRequired,
    analytics: initialAnalytics,
    preferences: initialPreferences,
    showDialog: initialShowDialog,
    supportPin: initialSupportPin,
    supportPinData: null,
  },
  reducers: {
    setRequired(state, action) {
      state.required = action.payload;
      Cookies.set("sv_cookie_required", String(state.required), { expires: 365 });
    },
    setAnalytics(state, action) {
      state.analytics = action.payload;
      Cookies.set("sv_cookie_analytics", String(state.analytics), { expires: 365 });
    },
    setPreferences(state, action) {
      state.preferences = action.payload;
      Cookies.set("sv_cookie_preferences", String(state.preferences), { expires: 365 });
    },
    setShowDialog(state, action) {
      state.showDialog = action.payload;
    },
    setSupportPin(state, action) {
      state.supportPin = action.payload;
    },
    setSupportPinData(state, action) {
      state.supportPinData = action.payload;
    },
  },
});

export const cookieActions = cookieSlice.actions;

export default cookieSlice;
